import request from '@/utils/request'

// 获取机构信息
export function grandInfo(params){
    return request({
        url: "/OA/OAunion/GetGrandInfo",
        method: "get",
        params
    })
}